import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminAreaApi as n } from "@maat/api-main";
//#region src/areas/admin/useAdminAttractionsQuery.ts
var r = (r, i) => t({
	queryKey: e.attractions(r ?? "", i),
	queryFn: () => n.listAttractions(r, i),
	enabled: !!r
});
//#endregion
export { r as useAdminAttractionsQuery };
